import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import * as Portal from '@radix-ui/react-portal';
import { AiOutlineCheckCircle, AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  addComment,
  deleteNote,
  resetActiveEntityId,
  selectActiveEntityId,
  setActiveEntityId,
} from '../../redux/notesetting/notesSettingsSlice';
import { put } from '../../config/dataService/dataService';
import { MessageType, showNotification } from '../../app_components/common/CommonStyle';
import ExternalCreateNoteForm from './ExternalCreateNoteForm';
import ExternalComment from './ExternalComment';
import ExternalNoteForm from './ExternalNoteForm';

const ExternalNote = ({ note, setCommentsData, workflowContactId }) => {
  const urls = {
    ActiveIsresolve: 'ProofComment/CommentActiveDeActive',
  };

  const { id, coords, comments, targetSelector } = note;
  const dispatch = useDispatch();
  const activeNoteId = useSelector(selectActiveEntityId);

  const ActiveOrInactive = async (activeNoteId) => {
    try {
      const result = await put(`${urls.ActiveIsresolve}?id=${activeNoteId}`);
      if (result && result.flag) {
        showNotification(MessageType.Success, result.message);
      } else {
        showNotification(MessageType.error, result.message);
      }
    } catch (error) {
      showNotification(MessageType.CatchError, '');
    }
  };

  return (
    <Popover.Root
      // open={activeNoteId === id}
      onOpenChange={(isOpen) => (isOpen ? dispatch(setActiveEntityId(id)) : dispatch(resetActiveEntityId()))}
      modal={true}
    >
      <Portal.Root
        onClick={(e) => e.preventDefault()}
        className="note"
        container={document.querySelector(targetSelector)}
        style={{
          transform: `translate3d(${coords.x.size + coords.x.unit}, ${coords.y.size + coords.y.unit}, 0)`,
        }}
      >
        <Popover.Trigger className="note-pin pin" />
      </Portal.Root>

      <Popover.Portal>
        <Popover.Content className="note-container" side="right" sideOffset={20}>
          <div className="note-header">
            <div className="buttons">
              <Popover.Close className="note-icons-btn">
                <AiOutlineClose />
              </Popover.Close>
            </div>
          </div>
          <div className="comments-container">
            {Array.isArray(comments) &&
              comments.map((comment) => {
                const { id } = comment;

                return (
                  <ExternalComment
                    key={id}
                    workflowContactId={workflowContactId}
                    commentDetails={comment}
                    alreadyExists={setCommentsData}
                  />
                );
              })}
          </div>
          <div className="custom-get-review-image-form form-container">
            <img src={require('../../static/img/No_image_available.png')} alt="" />
            <ExternalNoteForm
              note={note}
              workflowContactId={workflowContactId}
              onSubmit={(text) => dispatch(addComment({ id, text }))}
              noteId={activeNoteId}
            />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default ExternalNote;
